import { createRouter, createWebHashHistory } from 'vue-router'
import { ROUTE_META, ROUTE_PATHS } from '@/constants'
import { getStorage } from '@/platform/storage'

const routes = [
  { path: '/', redirect: ROUTE_PATHS.home },
  { path: ROUTE_PATHS.home, component: () => import('@/views/home/HomePage.vue'), meta: { [ROUTE_META.tab]: true } },
  { path: ROUTE_PATHS.device, component: () => import('@/views/device/DevicePage.vue'), meta: { [ROUTE_META.tab]: true } },
  { path: ROUTE_PATHS.profile, component: () => import('@/views/profile/ProfilePage.vue'), meta: { [ROUTE_META.tab]: true } },
  { path: '/pages/profile/edit', component: () => import('@/views/profile/ProfileEditPage.vue') },
  { path: ROUTE_PATHS.login, component: () => import('@/views/auth/LoginPage.vue'), meta: { [ROUTE_META.public]: true, [ROUTE_META.plain]: true } },
  { path: '/pages/register/index', component: () => import('@/views/auth/RegisterPage.vue'), meta: { [ROUTE_META.public]: true, [ROUTE_META.plain]: true } },
  { path: '/pages/retrieve-password/index', component: () => import('@/views/auth/RetrievePasswordPage.vue'), meta: { [ROUTE_META.public]: true, [ROUTE_META.plain]: true } },
  { path: '/pages/agent/index', component: () => import('@/views/agent/AgentPage.vue') },
  { path: '/pages/agent/edit', component: () => import('@/views/agent/AgentEditPage.vue') },
  { path: '/pages/chat/conversation', component: () => import('@/views/chat/ChatPage.vue') },
  { path: '/pages/credit-store/index', component: () => import('@/views/credit/CreditStorePage.vue') },
  { path: '/pages/credit-history/index', component: () => import('@/views/credit/CreditHistoryPage.vue') },
  { path: '/pages/orders/index', component: () => import('@/views/order/OrdersPage.vue') },
  { path: '/pages/subscription/index', component: () => import('@/views/order/SubscriptionPage.vue') },
  { path: '/pages/model-pricing/index', component: () => import('@/views/order/ModelPricingPage.vue') },
  { path: '/pages/payment/success', component: () => import('@/views/order/PaymentSuccessPage.vue') },
  { path: '/pages/timbre-management/index', component: () => import('@/views/media/TimbrePage.vue') },
  { path: '/pages/expression-manage/index', component: () => import('@/views/media/ExpressionPage.vue') },
  { path: '/:pathMatch(.*)*', component: () => import('@/views/common/NotFoundPage.vue'), meta: { [ROUTE_META.public]: true } },
]

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach((to) => {
  if (!to.meta[ROUTE_META.public] && !getStorage('token')) {
    // 保留来源路径，登录后可回跳（对齐 UniApp redirect 行为）
    return {
      path: ROUTE_PATHS.login,
      query: { redirect: to.fullPath },
    }
  }
  return true
})
